import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import PracticeAreas from "@/pages/PracticeAreas";
import SuccessStories from "@/pages/SuccessStories";
import About from "@/pages/About";
import CaseReview from "@/pages/CaseReview";
import CaseReviewSuccess from "@/pages/CaseReviewSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import { AdminSubmissions, AdminSubmissionDetail } from "@/pages/AdminSubmissions";
import AdminSuccessStories from "@/pages/AdminSuccessStories";

function PublicLayout() {
  return (
    <>
      <Nav />
      <Outlet />
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle emergent oauth callback synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/practice-areas" element={<PracticeAreas />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/about" element={<About />} />
        <Route path="/case-review" element={<CaseReview />} />
        <Route path="/case-review/success" element={<CaseReviewSuccess />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="submissions" element={<AdminSubmissions />} />
        <Route path="submissions/:id" element={<AdminSubmissionDetail />} />
        <Route path="success-stories" element={<AdminSuccessStories />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
